export default {
  blik__title: 'Завершите оплату переводом BLIK',
  blik__intro: 'Чтобы завершить оплату, сделайте перевод на номер телефона ниже.',

  blik__phone_label: 'Переведите на этот номер',
  blik__full_name_label: 'Имя и фамилия получателя',
  blik__amount_label: 'Сумма перевода',
  blik__time_remaining: 'Оставшееся время',

  blik__step_1: 'Откройте банковское приложение (или интернет-банк).',
  blik__step_2: 'Выберите перевод на номер телефона (BLIK P2P).',
  blik__step_3: 'Введите номер телефона: <b>{customer_phone}</b>',
  blik__step_4: 'Убедитесь, что имя и фамилия получателя совпадают. Если поле не является обязательным — пропустите этот шаг.',
  blik__step_5: 'Введите сумму: <b>{amount} {currency}</b>',
  blik__step_6: 'Подтвердите перевод и вернитесь на эту страницу.',

  blik__after_transfer:
    'После выполнения перевода статус платежа обновится автоматически. Это может занять немного времени.',

  blik__info_banner: 'Сделайте перевод в банковском приложении, чтобы подтвердить платеж.',

  blik__btn_confirm: 'Я сделал(а) перевод',
  blik__btn_cancel: 'Отменить и вернуться',

  blik__note_1: 'Если вы не выполните перевод, платеж не будет подтвержден.',
  blik__note_2: 'Если инструкция истечет (если показано), создайте новый платеж и попробуйте снова.',
};
